"use client";
import React, { useState, useRef, useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
// import Image from "next/image";
import { Sidebar } from "primereact/sidebar";
import { Dropdown } from "primereact/dropdown";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FileUpload } from "primereact/fileupload";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import downvector from '../../../assets/images/DownVector.svg';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import TopLinesChart from "../charts/toplineschart";
import { color } from "echarts";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import LoaderContainer from "../../../components/LoaderContainer/LoaderContainer";
import { xlsxExport } from "../../../components/chartwrapper/excelDownload";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { fetchStudent_Pop_Up_Trend, fetchStudent_Top_tile_7day_school_popup } from "../../../redux/slices/attendance";

export default function AttendanceBottomBar2(props) {
    const { visible, onHide, setActiveIndexList, title } = props;

    const [date, setDate] = useState(() => {
        const today = new Date();
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(today.getDate() - 6); // 6 days before today = 7 days total including today
        return [sevenDaysAgo, today] || [];
    });
    const [appliedDates, setAppliedDates] = useState(() => {
        const today = new Date();
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(today.getDate() - 6); // 6 days before today = 7 days total including today
        return [sevenDaysAgo, today];
    });

    const [visibleDetailTable, setVisibleDetailTable] = useState(false);
    const [selectedSchool, setSelectedSchool] = useState(null);
    const calendarRef = useRef(null);

    /* Redux State */
    const dispatch = useDispatch();

    // Student Wise
    const Student_Pop_Up_Trend = useSelector(state => state.attendance.Student_Pop_Up_Trend);
    const Student_Pop_Up_TrendLoading = useSelector(state => state.attendance.Student_Pop_Up_Trendloading);

    // School Wise 
    const Student_Top_tile_7day_school_popup = useSelector(state => state.attendance.Student_Top_tile_7day_school_popup);
    const Student_Top_tile_7day_school_popupLoading = useSelector(state => state.attendance.Student_Top_tile_7day_school_popuploading);

    // Filters
    const appliedfilter = useSelector(state => state.filter.appliedFilters);
    /* */

    /* API Call */
    useEffect(() => {
    if(visible && appliedDates[0] && appliedDates[1]){
        dispatch(fetchStudent_Top_tile_7day_school_popup({
            "elasticQueryName": "Student_Top_tile_7day_school_popup",
            // "filters": appliedfilter?.filter(itr => itr?.columnName == 'SCHOOL_YEAR'),
            "filters": appliedfilter,
            "dynamicColumns": [
                { columnName: "#{start_date}", columnValue: appliedDates?.[0].toLocaleDateString('en-CA'), "excludeKeyword": false},
                { columnName: "#{end_date}", columnValue: appliedDates?.[1].toLocaleDateString('en-CA'), "excludeKeyword": false }
            ],
        }));
    }
    },[visible, appliedDates, appliedfilter])

    useEffect(() => {
    if(visibleDetailTable){
        dispatch(fetchStudent_Pop_Up_Trend({
            "elasticQueryName": "Student_Pop_Up_Trend",
            "filters": [{ "columnName": "SCHOOL_OFFICIAL_NAME", "columnValue": selectedSchool, "excludeKeyword": false }].concat(appliedfilter?.filter(itr => itr?.columnName == 'SCHOOL_YEAR')),
            "dynamicColumns": [
                { columnName: "#{start_date}", columnValue: appliedDates?.[0].toLocaleDateString('en-CA'), "excludeKeyword": false},
                { columnName: "#{end_date}", columnValue: appliedDates?.[1].toLocaleDateString('en-CA'), "excludeKeyword": false }
            ],
        }));
    }
    },[visibleDetailTable, appliedfilter])
    /* */

    /* Two Months Restricted*/
    const today = new Date();
    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(today.getMonth() - 2);
    /* */

    // Handle Apply button click
    const applyFilter = () => {
        setAppliedDates(date);
        calendarRef.current?.hide();
        // Call your filtering logic here with selectedDates
    };

    // Handle Reset button click
    const resetFilter = () => {
        const resetToday = new Date();
        const resetWeekAgo = new Date();
        resetWeekAgo.setDate(resetToday.getDate() - 6);

        setDate([resetWeekAgo, resetToday]);
        setAppliedDates([resetWeekAgo, resetToday]);

        calendarRef.current?.hide();
        // Reset filter logic here
    };

    const handleSchoolClick = (rowData) => {
        setSelectedSchool(rowData?.SCHOOL_OFFICIAL_NAME);
        setVisibleDetailTable(true);
    };

    const schoolNameTemplate = (rowData) => (
        <span
            style={{ cursor: 'pointer' }}
            onClick={() => handleSchoolClick(rowData)}
        >
            <u>{rowData.SCHOOL_OFFICIAL_NAME}</u>
        </span>
    );

    const TableFilterTemplate = (options) => {
        return (
            <div className="relative flex items-center">
                <i className="pi pi-search absolute left-3 text-gray-500 text-sm"></i>
                <InputText
                    value={options.value}
                    onChange={(e) => options.filterCallback(e.target.value)}
                    placeholder="Search here"
                    className="pl-10 pr-3 py-1.5 border border-blue-300 rounded-md w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
            </div>
        );
    };
    return (
        <>
            <Sidebar
                visible={visible}
                onHide={onHide}
                position="bottom"
                className="bottomBar w-full bg-[#15181F]"
                blockScroll={true}
            >
                <div className="px-[30px] py-[15px] pb-1">
                    <div className="mb-[15px] flex justify-between">
                        <div className="text-[20px] text-[#fff] pl-[130px] pt-[10px] ">Last 7 Days Absentees Trend</div>
                        <div className="flex gap-10 items-center">
                            <Calendar
                                ref={calendarRef}
                                value={date}
                                onChange={e => setDate(e.value)}
                                selectionMode="range"
                                readOnlyInput
                                disabledDays={[0,6]}
                                showIcon
                                // showButtonBar
                                minDate={twoMonthsAgo}
                                maxDate={today}
                                dateFormat="dd/mm/yy"
                                placeholder="Select Date Range"
                                className="bg-[#1b2a37] text-[#fff] rounded-md shadow"
                                inputClassName="w-full px-3 py-2 text-sm shadow-none text-white bg-[#1b2a37]"
                                panelClassName="custCalendar"
                                footerTemplate={() =>  
                                    <div style={{display: "flex", justifyContent: "space-between", gap: "8px", padding: "0.5rem" }}>
                                        <button type="button" onClick={resetFilter} className="p-button p-component p-button-text text-white">
                                            Reset
                                        </button>
                                        <button type="button" onClick={applyFilter} className="p-button p-component p-button-primary text-white" disabled={!date || date.length < 2}>
                                            Apply
                                        </button>
                                    </div>
                                }
                            />
                            <button onClick={() => xlsxExport({sheetname: 'School-Wise', filename: title, data: Student_Top_tile_7day_school_popup })} className="bg-[#2E265A] text-[16px] leading-[16px] text-[#fff] rounded-full px-4 py-4 shadow ">Export XLS</button>
                        </div>
                    </div>
                    <div className="bg-[#1a2025cc]">
                        <div className="text-[16px] text-[#fff] leading-[24px] px-4 py-2 ">Detailed View of - {title}</div>
                        <div className="">
                            <LoaderContainer loading={Student_Top_tile_7day_school_popupLoading} height={'25rem'} width={'100%'}>
                            <DataTable
                                value={Student_Top_tile_7day_school_popup}
                                className="staffTable"
                                scrollable
                                scrollHeight="24.5rem"
                                paginator // Paginator Enable
                                rows={10} // Number of rows per page
                                rowsPerPageOptions={[10, 20, 30]} // Options in Paginator Dropdown
                                style={{ width: "100%" }}
                                emptyMessage={
                                    <div className="flex justify-center">
                                        No Data Available.
                                    </div>
                                }
                            >
                                <Column
                                    field="SCHOOL_YEAR"
                                    header="School Year"
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                    // style={{ maxWidth: "4rem" }}
                                ></Column>
                                <Column
                                    field="SCHOOL_ID"
                                    header="School ID"
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                    // style={{ maxWidth: "4rem" }}
                                ></Column>
                                <Column
                                    field="SCHOOL_OFFICIAL_NAME"
                                    header="School Name"
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                    // style={{ minWidth: "8rem" }}
                                    body={schoolNameTemplate}
                                ></Column>
                                <Column
                                    field="INCIDENT_TIME"
                                    header="Absent Date"
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                // style={{ minWidth: "8rem" }}
                                ></Column>
                                <Column
                                    field="METRIC_NUMERATOR"
                                    header="# of Absences"
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                // style={{ minWidth: "8rem" }}
                                ></Column>
                            </DataTable>
                            </LoaderContainer>
                        </div>
                    </div>
                </div>
            </Sidebar>
            <Sidebar
                visible={visibleDetailTable} onHide={() => setVisibleDetailTable(false)}
                position="bottom"
                className="bottomBar w-full bg-[#15181F]"
                blockScroll={true}
            >
                <div className="p-[30px]">
                    <div className="mb-[30px] flex justify-between">
                        <div className="text-[20px] text-[#fff] pl-[130px] pt-[10px] ">Last 7 Days Absentees Trend</div>
                        <button onClick={() => xlsxExport({sheetname: 'Student-Wise', filename: "Last 7 Days Absentees Trend", data: Student_Pop_Up_Trend })} className="bg-[#2E265A] text-[16px] leading-[16px] text-[#fff] rounded-full px-4 py-4 shadow ">Export XLS</button>
                    </div>
                    <div className="bg-[#1a2025cc]">
                        <div className="text-[16px] text-[#fff] leading-[24px] p-4 ">Detailed View of - Last 7 Days Absentees Trend</div>
                        <div className="">
                        <LoaderContainer loading={Student_Pop_Up_TrendLoading} height={'20rem'} width={'100%'}>
                            <DataTable
                                value={Student_Pop_Up_Trend}
                                className="staffTable"
                                scrollable
                                scrollHeight="24.5rem"
                                paginator // Paginator Enable
                                rows={10} // Number of rows per page
                                rowsPerPageOptions={[10, 20, 30]} // Options in Paginator Dropdown
                                style={{ width: "100%" }}
                                >
                                <Column
                                    field="STUDENT_ID"
                                    header="Student ID"
                                    // style={{ maxWidth: "4rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="STAFF_NAME"
                                    header="First Name"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="LAST_NAME"
                                    header="Last Name"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="GRADE"
                                    header="Grade"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="LOCATION"
                                    header="Location"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="GENDER"
                                    header="Gender"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="ETHNICITY"
                                    header="Ethnicity"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="ABSENTEES"
                                    header="Absences"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="ABSENCE_REASON"
                                    header="Absences Reason"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                            </DataTable>
                        </LoaderContainer>
                        </div>
                    </div>
                </div>
            </Sidebar>
        </>
    )
}